import React, { useState } from 'react';
import { fazerLogin } from '../../servicos/api';
import { useAutenticacao } from '../../contextos/AutenticacaoContexto';
import styles from './Login.module.css';
import CarregandoSobreposto from '../CarregandoSobreposto/CarregandoSobreposto';

const Login = () => {
  const [nome, setNome] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const { fazerLogin: salvarLogin } = useAutenticacao();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);

    if (!nome || !senha) {
      setErro('Nome e senha são obrigatórios');
      setCarregando(false);
      return;
    }

    try {
      const { token } = await fazerLogin(nome, senha);
      salvarLogin(token, nome);
    } catch (error) {
      setErro(error);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <>
      {carregando && <CarregandoSobreposto />}
      <div className={styles.container}>
        <div className={styles.cartaoLogin}>
          <h1 className={styles.titulo}>Baixador de Vídeos</h1>
          <p className={styles.subtitulo}>Baixador de Vídeos</p>

          <form onSubmit={handleSubmit} className={styles.formulario}>
            <div className={styles.grupoFormulario}>
              <label htmlFor="nome" className={styles.label}>
                Usuário
              </label>
              <input
                id="nome"
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                placeholder="Digite seu usuário"
                className={styles.entrada}
                disabled={carregando}
              />
            </div>

            <div className={styles.grupoFormulario}>
              <label htmlFor="senha" className={styles.label}>
                Senha
              </label>
              <input
                id="senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="Digite sua senha"
                className={styles.entrada}
                disabled={carregando}
              />
            </div>

            {erro && <div className={styles.mensagemErro}>{erro}</div>}

            <button
              type="submit"
              className={styles.botao}
              disabled={carregando}
            >
              {carregando ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <p className={styles.rodape}>
            Faça login para começar a baixar seus vídeos preferidos
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
